'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineVideoEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseAlerts = require('@bibliocommons/base-alerts');

var _videoForm = require('../../video-form');

var _videoForm2 = _interopRequireDefault(_videoForm);

var _videoPreview = require('../../video-preview');

var _videoPreview2 = _interopRequireDefault(_videoPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineVideoEditor = exports.InlineVideoEditor = function (_React$Component) {
  _inherits(InlineVideoEditor, _React$Component);

  function InlineVideoEditor(props) {
    _classCallCheck(this, InlineVideoEditor);

    var _this = _possibleConstructorReturn(this, (InlineVideoEditor.__proto__ || Object.getPrototypeOf(InlineVideoEditor)).call(this, props));

    _this.state = {
      focusTitle: false
    };
    return _this;
  }

  _createClass(InlineVideoEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* testing goodness */}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.showForm && nextProps.showForm) {
        this.setState({
          focusTitle: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bibId = _props.bibId,
          description = _props.description,
          deleted = _props.deleted,
          embedSnippet = _props.embedSnippet,
          iFrameSrc = _props.iFrameSrc,
          isNew = _props.isNew,
          isPrivate = _props.isPrivate,
          fieldErrors = _props.fieldErrors,
          handleCancel = _props.handleCancel,
          handleCancelPreview = _props.handleCancelPreview,
          handleDelete = _props.handleDelete,
          handleDescriptionChange = _props.handleDescriptionChange,
          handleEmbedSnippetChange = _props.handleEmbedSnippetChange,
          handlePrivacyToggle = _props.handlePrivacyToggle,
          handleShowForm = _props.handleShowForm,
          handleSubmit = _props.handleSubmit,
          handleTitleChange = _props.handleTitleChange,
          showForm = _props.showForm,
          videoTitle = _props.videoTitle;


      if (deleted) {
        return _react2.default.createElement(
          _baseAlerts.AlertSuccess,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'video_deleted' })
        );
      }

      if (showForm) {
        return _react2.default.createElement(_videoForm2.default, {
          fieldErrors: fieldErrors,
          description: description,
          embedSnippet: embedSnippet,
          focusTitle: this.state.focusTitle,
          iFrameSrc: iFrameSrc,
          isNew: isNew,
          handleCancel: handleCancel,
          handleCancelPreview: handleCancelPreview,
          handleDelete: handleDelete,
          handleDescriptionChange: handleDescriptionChange,
          handleEmbedSnippetChange: handleEmbedSnippetChange,
          handleSubmit: handleSubmit,
          handleTitleChange: handleTitleChange,
          submitButtonText: 'update_video',
          videoTitle: videoTitle });
      }

      return _react2.default.createElement(_videoPreview2.default, {
        bibId: bibId,
        description: description,
        handleDelete: handleDelete,
        handleShowForm: handleShowForm,
        handlePrivacyToggle: handlePrivacyToggle,
        iFrameSrc: iFrameSrc,
        isPrivate: isPrivate,
        showActions: true,
        videoTitle: videoTitle });
    }
  }]);

  return InlineVideoEditor;
}(_react2.default.Component);

InlineVideoEditor.propTypes = {
  deleted: _react.PropTypes.bool,
  videoTitle: _react.PropTypes.string,
  description: _react.PropTypes.string,
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  handleCancel: _react.PropTypes.func.isRequired,
  handleCancelPreview: _react.PropTypes.func.isRequired,
  handleDescriptionChange: _react.PropTypes.func.isRequired,
  handleEmbedSnippetChange: _react.PropTypes.func.isRequired,
  handleShowForm: _react.PropTypes.func,
  handleDelete: _react.PropTypes.func,
  handleSubmit: _react.PropTypes.func.isRequired,
  handleTitleChange: _react.PropTypes.func.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  bibId: _react.PropTypes.number.isRequired,
  iFrameSrc: _react.PropTypes.string,
  isNew: _react.PropTypes.bool,
  showForm: _react.PropTypes.bool,
  embedSnippet: _react.PropTypes.string
};

exports.default = InlineVideoEditor;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/inline-video-editor/components/InlineVideoEditor.js
// module id = 1522
// module chunks = 1